import axios from 'axios';

const encodeParams = (params : Record<string, any>) => {
  const query = [];

  for (const key in params) {
    if (Array.isArray(params[key])) {
      // Handle array format (e.g., sort[0].field)
      params[key].forEach((item, index) => {
        if (typeof item === 'object') {
          for (const subKey in item) {
            query.push(`${key}[${index}].${subKey}=${encodeURIComponent(item[subKey])}`);
          }
        } else {
          query.push(`${key}[${index}]=${encodeURIComponent(item)}`);
        }
      });
    } else if (typeof params[key] === 'object') {
      // Handle nested objects (no array)
      for (const subKey in params[key]) {
        query.push(`${key}.${subKey}=${encodeURIComponent(params[key][subKey])}`);
      }
    } else {
      query.push(`${key}=${encodeURIComponent(params[key])}`);
    }
  }

  return query.join('&');
};

const useAxiosInstance = axios.create({
  withCredentials: true,
  paramsSerializer: (params) => encodeParams(params)
});


export default useAxiosInstance;

export interface AxiosInstanceResponse {
  success?: boolean;
  errors?: string[];
}